import { ClientApi } from "@/api/ClientApi";
import { ZoneApi } from "@/api/ZoneApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { LAST_YEARS, MONTHS, REPORT_EXCEL_FORMAT, REPORT_FORMATS, REPORT_PRINT_FORMAT, } from "@utils/Constants";

const BuyReportFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "clientId",
                        "label": "Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const clients = await ClientApi.optionsList();
                            return {
                                "-2": "Todos los Clientes",
                                ...clients
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "zoneId",
                        "label": "Zona de Cliente",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const zones = await ZoneApi.optionsList();
                            return {
                                "-2": "Todos las Zonas",
                                ...zones
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "month",
                        "label": "Mes",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": MONTHS,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "year",
                        "label": "Año",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": LAST_YEARS,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "format",
                        "label": "Formato",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": REPORT_FORMATS,
                        "defaultValue": REPORT_PRINT_FORMAT,
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "detallarIva",
                        "label": "Detallar total IVA",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        },
                        "defaultValue": false,
                        "visibleIf": {
                            "format": REPORT_EXCEL_FORMAT
                        }
                    }
                ],
            ]
        }
    ],
};


export default BuyReportFormConfig;